import colors from '../../utils/colors';
import type { AlertType } from './types';

export const FONT_SIZE = 13;
export const BORDER_RADIUS = 12;

export const colorsByType: Record<AlertType, string> = {
  error: colors.error100,
  success: colors.success100,
  info: colors.ink100,
};

export const backgroundColorsByType: Record<AlertType, string> = {
  error: colors.error100,
  success: colors.success100,
  info: colors.cream100,
};

export const namesByType: Record<AlertType, string> = {
  error: 'exclamation-circle',
  success: 'check-circle',
  info: 'exclamation-circle',
};
